import React from 'react';
import { Section } from './ui/Section';
import { Heart, Star } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  name: 'María',
  location: 'Mamá de 2 niños',
  text: '"Antes llegaba a las 7pm sin saber qué hacer de cena y terminaba pidiendo comida rápida. Con este sistema, en mi primer domingo preparé la base y entre semana solo tardé 12 minutos cada noche. Mis hijos ahora me piden repetir las cenas. ¡No lo puedo creer!"',
  image: 'https://cdn.magicpatterns.com/uploads/rSe4qCpNs4aTVjwk1QMeKZ/thumb.jpg'
}, {
  name: 'Eliana',
  location: 'Mamá soltera, trabaja tiempo completo',
  text: '"Pensé que era otra guía más de recetas que iba a terminar olvidada. Pero no — esto es un sistema de verdad. La primera semana ahorré casi $30 en delivery y mis noches dejaron de ser una batalla. Ahora cocino tranquila mientras mi hija hace tarea. Mejor inversión que he hecho."',
  image: 'https://cdn.magicpatterns.com/uploads/f5h4TVyyk4L5uk1jocLVXX/thumb.jpg'
}];
export function ProofSection() {
  return <Section bg="cream" data-id="element-196">
      <div className="max-w-3xl mx-auto text-center" data-id="element-197">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-[#F59E0B]/20 rounded-full mb-6 text-[#EA580C]" data-id="element-198">
          <Heart size={32} fill="currentColor" data-id="element-199" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-[#422006] mb-6 leading-snug" data-id="element-200">
          Este sistema no nació en una escuela de cocina, nació en el caos real
          de una mamá que no tenía quién la ayudara.
        </h2>
        <p className="text-lg md:text-xl text-[#78350F] leading-relaxed mb-16" data-id="element-201">
          Al simplificar la toma de decisiones (solo 1 base, solo 3 ingredientes
          extra), eliminas la fatiga mental. En la primera semana, notarás que
          tu cocina está más limpia y tu nivel de estrés a las 6:30 PM ha bajado
          un 80%.
        </p>

        {/* Testimonials */}
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-202">
          {testimonials.map((t, i) => <motion.div key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.15
        }} className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-[#F59E0B]/15 text-left relative" data-id="element-203">
              {t.emoji && !t.image && <div className="absolute -top-4 -left-2 text-3xl" data-id="element-204">
                  {t.emoji}
                </div>}
              {t.image && <div className="mb-4" data-id="element-205">
                  <img src={t.image} alt={t.name} className="w-16 h-16 rounded-full object-cover border-2 border-[#F59E0B]/30 shadow-sm" data-id="element-206" />
                </div>}
              <div className="flex gap-1 mb-4" data-id="element-207">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} className="text-[#F59E0B] fill-[#F59E0B]" data-id="element-208" />)}
              </div>
              <p className="text-[#78350F] leading-relaxed mb-5 text-[15px]" data-id="element-209">
                {t.text}
              </p>
              <div className="border-t border-[#F59E0B]/10 pt-4" data-id="element-210">
                <p className="font-bold text-[#422006]" data-id="element-211">{t.name}</p>
                <p className="text-sm text-[#78350F] opacity-70" data-id="element-212">
                  {t.location}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}